//ハンバーガーメニュー
export default class Hamburger {
  constructor(TARGET = ".headerNavi", OPEN = "-open") {
    this.target = TARGET;
    this.open = OPEN;
    const nav = document.querySelector(TARGET);
    const btn = nav?.querySelector(".ac_menu");
    const btn_label = nav?.querySelector(".ac_menu span");
    const wrap = nav?.querySelector(".naviWrapper");
    const close_btn = nav?.querySelector(".closeBtn");
    const atag = nav?.querySelectorAll('a[href*="#"]');

    btn?.addEventListener("click", () => {
      nav?.classList.toggle(OPEN);

      if (nav?.classList.contains(OPEN)) {
        btn.setAttribute("aria-expanded", "true");
        btn_label.textContent = "CLOSE";
        pointerEvents("auto");
      } else {
        btn.setAttribute("aria-expanded", "false");
        btn_label.textContent = "MENU";

        pointerEvents("none");
      }
    });
    close_btn?.addEventListener("click", () => {
      menuClose();
    });

    atag?.forEach((a) => {
      a.addEventListener("click", () => {
        menuClose();
      });
    });

    wrap?.addEventListener("click", (e) => {
      const target = e.target;
      if (target.closest("#navi") === null) {
        menuClose();
      }
    });

    const menuClose = () => {
      nav?.classList.remove(OPEN);
      btn.setAttribute("aria-expanded", "false");
      btn_label.textContent = "MENU";
    };

    function subMenu() {
      const ac = document.querySelectorAll(".c-accordion_btn");
      const HEIGHT = "--subHeightOpen"; //開いた時の高さ
      const OFFSET_TIME = 5; //ディレイ
      let openFlg = false;
      const SPEED = 250;

      ac.forEach((btn) => {
        btn?.addEventListener("click", () => {
          const subMenu = btn.closest("div")?.nextElementSibling;
          if (!openFlg) {
            subMenu.classList.add("-open"); // クラスの追加
            btn.classList.add("-open");

            let height = subMenu.offsetHeight; //高さ取得
            subMenu.style.setProperty(HEIGHT, "0"); //アニメーション開始用の0

            // open付与から少しだけ遅らせた方が動作が安定する
            setTimeout(() => {
              // ※ コンテンツの高さはopenを付けたあとで取得しないと iOSで０になる
              subMenu.style.setProperty(HEIGHT, `${height}px`);
              openFlg = true;
            }, OFFSET_TIME);
          } else if (openFlg) {
            // アニメーション
            subMenu.style.setProperty(HEIGHT, "0");
            btn.classList.remove("-open");

            // アニメーション完了後にopenクラスを削除。（CSS側のアニメーション時間+少しだけ余裕をもたせている）
            setTimeout(() => {
              subMenu.classList.remove("-open"); // クラスを削除
              openFlg = false;
              subMenu.style.setProperty(HEIGHT, "auto"); //アニメーションの後始末
            }, SPEED + OFFSET_TIME);
          }
        });
      });
    }
    subMenu();
    const elements = document.querySelectorAll(".l-header__menu__list > li");
    const anchors = document?.querySelectorAll(".subMenu_list > li");
    const subMenus = document.querySelectorAll(".subMenu a");
    elements?.forEach((e) => {
      e?.addEventListener("pointerenter", () => {
        // ホバー状態にする処理
        e.classList.add("hover");
      });
      e?.addEventListener("pointerleave", () => {
        // ホバー状態にする処理
        if (e.classList.contains("hover")) {
          e.classList.remove("hover");
        }
      });
    });
    subMenus?.forEach((e) => {
      e.addEventListener("focus", () => {
        //aタグがフォーカスを受け取った時
        const closet = e.closest(".l-header__menu__list > li");
        closet.classList.add("hover");
      });
      e.addEventListener("blur", () => {
        //aタグがフォーカスを失った時
        const closet = e.closest(".l-header__menu__list > li");
        closet.classList.remove("hover");
      });
    });
    anchors?.forEach((e) => {
      e?.addEventListener("click", () => {
        // ホバー状態にする処理
        const closet = e.closest(".hover");
        if (closet) {
          closet.classList.remove("hover");
        }
      });
    });

    //pointerEvent変更用関数
    function pointerEvents(event) {
      subMenus?.forEach((item) => {
        item.style.pointerEvents = event;
      });
    }

    const mediaQueryList = window.matchMedia("(max-width: 767px)"); // mediaクエリ

    const mmEvents = (event) => {
      if (event.matches) {
        pointerEvents("none");

        atag?.forEach((a) => {
          a.addEventListener("click", () => {
            pointerEvents("none");
          });
        });
      } else {
        pointerEvents("auto");
        atag?.forEach((a) => {
          a.addEventListener("click", () => {
            pointerEvents("auto");
          });
        });
      }
    };

    mediaQueryList.addEventListener("change", mmEvents);

    // 初期化処理
    mmEvents(mediaQueryList);
  }
}
